import moment from 'moment';

export const STATUS_CODE = {
  "DISPATCHED": {
    "lookupCode": "DISPATCHED",
    "lookupValue": "已派工"
  },
  "START_WORK": {
    "lookupCode": "START_WORK",
    "lookupValue": "已开工"
  },
  "COMPLETED": {
    "lookupCode": "COMPLETED",
    "lookupValue": "已完成"
  },
  "RECEIVED": {
    "lookupCode": "RECEIVED",
    "lookupValue": "已入库"
  },
  "CLOSED": {
    "lookupCode": "CLOSED",
    "lookupValue": "已关闭"
  }
}

export const TICKET_TABLE_TYPE = {
  ticketInfo: {
    label: 'MO票信息',
    value: 'mo'
  },
  materialInfo: {
    label: '用料清单',
    value: 'material'
  },
  process: {
    label: '工序清单',
    value: 'process'
  },
  relateBill: {
    label: '关联工单',
    value: 'relate'
  }
}

// 投料状态
export const FEED_STATUS = {
  notFeeding: { label: '未投料', value: 'N' },
  feeding: { label: '已投料', value: 'Y' }
}

export const YES_OR_NOT = {
  Y: '是',
  N: '否'
}
export function formatDate (date) {
  if(date) {
    return moment(date).format('YYYY-MM-DD HH:mm:ss')
  }
  return '';
}

export const TICKET_INFO_COL = [
  {
    // title: "工作中心",
    dataIndex: "workCenterName",
    scopedSlots: { title: "workCenterNameTitle" },
    width: 130,
    stickyFixed: 'left'
  },
  {
    // title: "班组",
    dataIndex: "teamGroupName",
    scopedSlots: { title: "teamGroupNameTitle" },
    width: 110,
    stickyFixed: 'left'
  },
  {
    title: "MO号",
    dataIndex: "wipEntityName",
    width: 140,
    stickyFixed: 'left'
  },
  {
    title: "MO票号",
    dataIndex: "moTicketCode",
    width: 130,
    stickyFixed: 'left'
  },
  {
    title: "业务类型",
    dataIndex: "businessTypeName",
    width: 90,
    stickyFixed: 'left'
  },
  {
    title: "计划单号",
    dataIndex: "orderNo"
  },
  {
    title: "父级工单号",
    dataIndex: "upstreamWorkNumber",
    width: 140
  },
  // {
  //   title: "MO状态",
  //   dataIndex: "ccStatusName",
  //   width: 100
  // },
  {
    title: "MO票状态",
    dataIndex: "moStatusName",
    width: 100
  },
  {
    title: "物料编码",
    dataIndex: "itemCode"
  },
  {
    title: "物料名称",
    dataIndex: "itemName",
    scopedSlots: { customRender: 'textEllipsis' }
  },
  { title: "工艺大类", dataIndex: "productBroadCategoryName" },
  {
    title: "规格描述",
    dataIndex: "specification",
    scopedSlots: { customRender: 'textEllipsis' }
  },
  {
    title: "计划数量",
    dataIndex: "planQuantity"
  },
  {
    title: "完工数量",
    dataIndex: "quantityCompleted"
  },
  {
    title: "剩余数量",
    dataIndex: "quantityRemaining"
  },
  {
    title: "已入库数量",
    dataIndex: "receivedQuantity"
  },
  {
    title: "已送货数量",
    dataIndex: "deliveredQuantity"
  },
  {
    // title: "计划开始时间",
    dataIndex: "scheduledStartDate",
    scopedSlots: { customRender: 'scheduledStartDate', title: "scheduledStartDateTitle" },
    width: 180
  },
  {
    // title: "计划完成时间",
    dataIndex: "scheduledCompletionDate",
    scopedSlots: { customRender: 'scheduledCompletionDate', title: "scheduledCompletionDateTitle" },
    width: 180
  },
  {
    title: "派工时间",
    dataIndex: "dispatchingDate",
    scopedSlots: { customRender: 'formatDate' },
    width: 120
  },
  {
    title: "开工时间",
    dataIndex: "startDate",
    scopedSlots: { customRender: 'formatDate' },
    width: 120
  },
  {
    title: "完工时间",
    dataIndex: "completionDate",
    scopedSlots: { customRender: 'formatDate' },
    width: 120
  },
  {
    title: "入库时间",
    dataIndex: "receivedDate",
    scopedSlots: { customRender: 'formatDate' },
    width: 120
  },
  {
    title: "一次考核交期",
    dataIndex: "deliveryDate",
    scopedSlots: { customRender: 'formatDate' },
    width: 120
  },
  {
    title: "变更后考核交期",
    dataIndex: "assessmentDeliveryDate",
    scopedSlots: { customRender: 'formatDate' },
    width: 120
  },
  {
    title: "第一次报工时间",
    dataIndex: "firstReportingTime",
    scopedSlots: { customRender: 'formatDate' },
    width: 120
  },
  {
    title: "是否合格",
    dataIndex: "qualifiedFlag",
    scopedSlots: { customRender: 'YES_OR_NOT' }
  },
  {
    title: "是否锁库",
    dataIndex: "lockStockFlag",
    scopedSlots: { customRender: 'YES_OR_NOT' }
  },
  {
    title: "完工子库",
    dataIndex: "completedSublibrary"
  },
  {
    title: "MO类型",
    dataIndex: "jobTypeName"
  },
  {
    title: "大货类型",
    dataIndex: "orderTypeName"
  },
  {
    title: "车间",
    dataIndex: "workShopDesc"
  },
  {
    title: "BOM版本号",
    dataIndex: "bomVersion"
  },
  {
    title: "备注",
    dataIndex: "remarks",
    scopedSlots: { customRender: 'textEllipsis' }
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    scopedSlots: { customRender: 'formatDate' },
    width: 120
  },
  { title: "需求组织", dataIndex: "organizationName", width: 140 },
  { title: "加工商组织", dataIndex: "desOrganizationName", width: 170 },
  {
    title: "操作",
    dataIndex: "operation",
    scopedSlots: { customRender: "operation" },
    width: 100,
    stickyFixed: 'right'
  }
]

// 表格字段-工单用料表
export const TICKET_MATERIAL_COL = [
  { title: '加工组织', dataIndex: 'desOrganizationName', width: 180, stickyFixed: 'left', align: 'center' },
  { title: '工单号', dataIndex: 'wipEntityName', width: 160, stickyFixed: 'left', align: 'center' },
  { title: '父工单号', dataIndex: 'upstreamWorkNumber', width: 160, stickyFixed: 'left', align: 'center' },
  { title: '工单状态', dataIndex: 'ccStatusName', width: 95, stickyFixed: 'left', align: 'center' },
  { title: '成品-物料编码', dataIndex: 'assemblyItemCode', stickyFixed: 'left', width: 160, align: 'center' },
  { title: '成品-物料名称', width: 160, dataIndex: 'assemblyItemName', align: 'center', ellipsis: true },
  { title: '成品-规格描述', dataIndex: 'assemblySpecification', width: 120, align: 'center', ellipsis: true },
  { title: '组件物料', dataIndex: 'itemCode', width: 120, align: 'center' },
  { title: '组件-物料名称', width: 120, dataIndex: 'itemName', align: 'center', ellipsis: true },
  { title: '组件-规格描述', dataIndex: 'specification', width: 180, align: 'center', ellipsis: true },
  { title: '单位', dataIndex: 'primaryUom', width: 120, align: 'center' },
  { title: '用量', dataIndex: 'quantityPerAssembly', width: 120, align: 'center' },
  { title: '产出率', dataIndex: 'componentYield', width: 120, align: 'center' },
  { title: '必须', dataIndex: 'requiredQuantity', width: 120, align: 'center' },
  { title: '已发料', dataIndex: 'quantityIssued', width: 120, align: 'center' },
  { title: '未发料', dataIndex: 'quantityOpen', width: 120, align: 'center' },
  { title: '供应类型', dataIndex: 'wipSupplyTypeName', width: 120, align: 'center' },
  { title: 'MRP净值', width: 120, dataIndex: 'mrpFlag', align: 'center', scopedSlots: { customRender: 'YES_OR_NOT' } },
  { title: '供应子库', width: 120, dataIndex: 'supplySublibrary', align: 'center' },
  { title: '供应货位', width: 120, dataIndex: 'supplyLocation', align: 'center' },
  { title: '需求日期', dataIndex: 'dateRequired', scopedSlots: { customRender: 'formatDate' }, width: 150, align: 'center' },
  { title: '创建人', width: 120, dataIndex: 'createName', align: 'center' },
  { title: '创建时间', dataIndex: 'createTime', scopedSlots: { customRender: 'formatDate' }, width: 150, align: 'center' },
  { title: '最后更新人', width: 120, dataIndex: 'updateName', align: 'center' },
  { title: '最后更新时间', dataIndex: 'updateTime', scopedSlots: { customRender: 'formatDate' }, align: 'center' }
]

// 表格字段-工序清单
export const TICKET_PROCESS = [
  { title: '加工组织', dataIndex: 'desOrganizationName', width: 180, stickyFixed: 'left', align: 'center' },
  { title: '工单号', width: 180, stickyFixed: 'left', dataIndex: 'wipEntityName', align: 'center' },
  { title: '工单状态', width: 120, dataIndex: 'ccStatusName', align: 'center' },
  { title: '物料编码', width: 160, dataIndex: 'assemblyItemCode', align: 'center' },
  { title: '物料名称', width: 160, dataIndex: 'assemblyItemName', align: 'center' },
  { title: '规格描述', width: 180, dataIndex: 'specification', align: 'center', ellipsis: true },
  { title: '工序序号', width: 160, dataIndex: 'operationSeqNum', align: 'center' },
  { title: '工序代码', width: 120, dataIndex: 'operationCode', align: 'center' },
  { title: '工序说明', width: 120, dataIndex: 'operationDesc', align: 'center' },
  { title: '是否防跳站', width: 100, dataIndex: 'skipFlag', align: 'center', scopedSlots: { customRender: 'skipFlag' } },
  { title: '车间', width: 120, dataIndex: 'workShopDesc', align: 'center' },
  { title: '工作中心', width: 120, dataIndex: 'workCenterName', align: 'center' },
  { title: '班组', width: 120, dataIndex: 'teamGroupName', align: 'center' },
  { title: '流转状态', width: 120, dataIndex: 'statusName', align: 'center' },
  { title: '需求数量', width: 120, dataIndex: 'requiredQty', align: 'center' },
  { title: '等待数量', width: 120, dataIndex: 'waitQty', align: 'center' },
  { title: '完成数量', width: 120, dataIndex: 'completedQty', align: 'center' },
  { title: '工序开工时间', dataIndex: 'processStartTime', width: 150, align: 'center' },
  { title: '第一次工序报工时间', dataIndex: 'firstReportingTime', width: 170, align: 'center' },
  { title: '最后一次工序报工时间', dataIndex: 'lastReportingTime', width: 170, align: 'center' },
  { title: '创建人', width: 120, dataIndex: 'createName', align: 'center' },
  { title: '创建时间', dataIndex: 'createTime', scopedSlots: { customRender: 'formatDate' }, width: 150, align: 'center' },
  { title: '最后更新人', width: 120, dataIndex: 'updateName', align: 'center' },
  { title: '最后更新时间', dataIndex: 'updateTime', scopedSlots: { customRender: 'formatDate' }, width: 150, align: 'center' }
]

export function positiveNumValidate(rule, value, callbackFunc) {
  if(value === undefined || value === '' || value === null) {
    callbackFunc('不能为空');
  } else if(value < 0) {
    callbackFunc('不可等于0')
  }else {
    callbackFunc()
  }
}
